import { useMemo } from 'react';
import type { Project, ProjectTypology } from '@/types/content';

export type FilterValue = 'all' | ProjectTypology;

interface ProjectFilterProps {
  projects: Project[];
  value: FilterValue;
  onChange: (value: FilterValue) => void;
}

const ORDER: ProjectTypology[] = ['residential', 'hospitality', 'commercial', 'multifamily', 'retail'];

/**
 * Typology tabs above the projects grid. Counts derived from the projects
 * array. Typologies with zero projects are hidden so the bar only shows
 * meaningful filters.
 */
export function ProjectFilter({ projects, value, onChange }: ProjectFilterProps) {
  const counts = useMemo(() => {
    const m = new Map<ProjectTypology, number>();
    for (const p of projects) {
      m.set(p.typology, (m.get(p.typology) ?? 0) + 1);
    }
    return m;
  }, [projects]);

  const present = ORDER.filter((t) => counts.has(t));

  return (
    <nav className="project-filter" aria-label="Filter projects by typology">
      <button
        type="button"
        className={`project-filter__tab ${value === 'all' ? 'is-active' : ''}`}
        onClick={() => onChange('all')}
        aria-pressed={value === 'all'}
      >
        <span className="project-filter__label">All</span>
        <span className="project-filter__count">{projects.length}</span>
      </button>
      {present.map((t) => (
        <button
          key={t}
          type="button"
          className={`project-filter__tab ${value === t ? 'is-active' : ''}`}
          onClick={() => onChange(t)}
          aria-pressed={value === t}
        >
          <span className="project-filter__label">{t}</span>
          <span className="project-filter__count">{counts.get(t)}</span>
        </button>
      ))}
    </nav>
  );
}
